import React from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 6rem;
`;

const NoSessionsDashboardView: React.FC = () => {
    const { t } = useTranslation('dashboard');

    return (
        <Container>
            <span>
                <strong>{t('no-dates')}</strong>
            </span>
            <span>{t('please-click-add-new')}</span>
        </Container>
    );
};

export default NoSessionsDashboardView;
